import globalTheme, { muiTheme } from '../global'

const Badge = {
	MuiBadge: {
		styleOverrides: {
			colorPrimary: {
				border: '3px solid ' + globalTheme.palette.common.white,
			},
			standard: {
				borderRadius: '100%',
				fontWeight: muiTheme.typography.fontWeightBold,
				height: 'auto',
				minHeight: 25,
				minWidth: 25,
				padding: 0,
				transform: 'scale(1) translate(calc(50% + 6px), -50%)',
			},
		},
	},
}

export default Badge
